import { useI18n, APP_LANGS, LANG_LABEL } from '../i18n';

/** Sélecteur de langue (pilule). Masqué si l'app ne déclare qu'une langue. */
export function LangSwitcher() {
  const { lang, setLang } = useI18n();
  if (APP_LANGS.length < 2) return null;
  return (
    <div className="mb-lang" role="group" aria-label="Langue">
      {APP_LANGS.map((l) => (
        <button
          key={l}
          className={`mb-lang-btn${l === lang ? ' is-active' : ''}`}
          onClick={() => setLang(l)}
          aria-pressed={l === lang}
        >
          {LANG_LABEL[l] ?? l.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
